import { defineStore } from 'pinia';

export const useIndustryStore = defineStore('industries', {
    state: () => ({
        industries: [] as any[],
        industry: null as any | null,
    }),
    actions: {
        async fetchIndustries() {
            return useNuxtApp().$api().v2.industries.list({
                retry: 3,
                retryDelay: 1500,
            }).then(response => {
                this.industries = response
                return response;
            });
        },
        async fetchIndustry(id: string) {
            this.industry = await useNuxtApp().$api().v2.industries.get(id);
        },
    }
})